export default (mutateArray, values) => {
  if(typeof values !== 'object' || values === null || values instanceof Array) return {};
  return mutateArray.reduce((acc, res) => {
    if(!acc.hasOwnProperty(res)) {
      acc = { ...acc, [res]: values[res] };
    }
    return acc;
  }, {});
};
